<template>
  <div class="lunbo">
    <img style="width: 400px; height: 300px" :src="ImgSrc">
    <p style="font-size: 20px">{{message}}</p>
  </div>
</template>

<script>
export default {
  name: 'lunbo',
  data() {
    console.log(this.ImgSrc, this.message)
    return {
     
    }
  },
  props: {
    ImgSrc: String,
    message: String,
}
}

</script>


<style>
.lunbo {
  width: 400px;
  height: 200px;
  margin-right: 2px;
  text-align: center;
}

</style>